module.exports = __webpack_public_path__ + "static/justinbons-2a6b317ecf7d9d4111ecf7d2a82accda.jpg";